import { useState } from 'react';
import { useFamilyStore } from '@/store/familyStore';
import { PersonalInfoRequest } from '@/types';

export function usePersonalInfoRequests() {
  const { 
    personalInfoRequests, 
    addPersonalInfo,
    updatePersonalInfoRequestStatus 
  } = useFamilyStore();
  const [selectedRequest, setSelectedRequest] = useState<PersonalInfoRequest | null>(null);

  const handleApprove = (request: PersonalInfoRequest) => {
    // Add personal info
    addPersonalInfo({
      id: Math.random().toString(36).substr(2, 9),
      ...request.personalInfo,
      createdAt: Date.now(),
      updatedAt: Date.now()
    });

    // Update request status
    updatePersonalInfoRequestStatus(request.id, 'approved');
    setSelectedRequest(null);
  };

  const handleReject = (requestId: string) => {
    updatePersonalInfoRequestStatus(requestId, 'rejected');
    setSelectedRequest(null);
  };

  return {
    requests: personalInfoRequests,
    selectedRequest,
    setSelectedRequest,
    handleApprove,
    handleReject
  };
}